/*
* Usage:
*
* <button data-email data-action-value="mailto:developers@stormcreative.co.uk">developers@stormcreative.co.uk</button>
*
* <button data-phone data-action-value="tel:+44723843278">+44 (0) 2387 237 232</button>
*/

import { findMany, on } from '../helpers';
import PhonePopUp from './phone';
import EmailPopUp from './email';

// Initialise a popup element with the given PopupClass
const initPopUp = (el, PopupClass) => {
    if (!el.getAttribute('data-popup-initialised')) {
        new PopupClass(el);
        el.setAttribute('data-popup-initialised', 'true');
    }
};

// Handle initialisation of phone and email popups
const handle = () => {
    findMany('[data-phone]').forEach(el => initPopUp(el, PhonePopUp));
    findMany('[data-email]').forEach(el => initPopUp(el, EmailPopUp));
};

// Attach event listeners to trigger popup initialisation
const attachEventListeners = () => {
    // Initialise popups when the page loads
    on('load', handle, window);

    // Reinitialise popups after an HTMX request
    on('htmx:afterRequest', handle, window);
};

attachEventListeners();
